import { MainLoggedInLayout } from "../../components/layouts/main.loggedIn.layout"
import ConversationList from "../../components/messages/ConversationList"
import { useContext } from "react"
import { UserContext } from "../../context/UserContext"
import { useProfileComplete } from "../../hooks/useProfileComplete"

export const MessageList = () => {
    const { userDetails } = useContext(UserContext)
    
    // Check profile completion and redirect if needed
    useProfileComplete(userDetails)
    
    return (
        <MainLoggedInLayout>
            <ConversationList />
        </MainLoggedInLayout>
    )
}